export default __webpack_public_path__ + "static/media/lanzamientos_activado.e47f5c24.svg";